import { all } from "redux-saga/effects";

//Watchers
import { bailSaga } from "./bail";
import { loginSaga } from "./login";
import { logoutSaga } from "./logout";
import { profileSaga } from "./profile";
import { resetSaga } from "./reset";
import { signupSaga } from "./signup";

export default function* authSagas() {
  yield all([signupSaga(), loginSaga(), profileSaga(), logoutSaga(), resetSaga(), bailSaga()]);
}



// WEBPACK FOOTER //
// ./src/sagas/auth/index.js